import { useEffect } from "react";
import { useHeader } from "../contexts/HeaderContext";
import { useView } from "../contexts/ViewContext";

export const PauseButton = () => {
    const { view } = useView();
    const { setShowPauseButton } = useHeader();

    useEffect(() => {
        setShowPauseButton(true);

        return () => setShowPauseButton(false);
    }, [view, setShowPauseButton]);

    return null; // this component doesn't render anything
}